import { render, staticRenderFns } from "./universal-form.vue?vue&type=template&id=180e6166&scoped=true&"
import script from "./universal-form.ts?vue&type=script&lang=ts&"
export * from "./universal-form.ts?vue&type=script&lang=ts&"
import style0 from "./universal-form.scss?vue&type=style&index=0&id=180e6166&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180e6166",
  null
  
)

export default component.exports